import styled from 'styled-components';

export const TriggeredAlertNotificationStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const TriggeredAlertNotificationHeaderStyled = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
`;

export const TriggeredAlertNotificationIconStyled = styled.div`
    padding: 4px;
    background: var(--color-fill-secondary);
    border-radius: 8px;
    display: inline-flex;
`;

export const TriggeredAlertNotificationTitleStyled = styled.div`
    flex: 1;
    font-weight: 600;
`;

export const TriggeredAlertNotificationPriceStyled = styled.div`
    background: var(--color-fill-secondary);
    padding: 2px 8px;
    border-radius: 8px;
    color: var(--color-label-primary);
    font-size: 12px;
    font-weight: 600;
`;
